import ErrorToast from './error-toast';

interface StandingErrorToastProps {
  message: string;
  onClose: () => void;
}

/**
 * An error toast that stays up until it is closed, for a failure the user must
 * see. Keyed by message, so a new reason shows as a new toast.
 * @param {StandingErrorToastProps} props - The message, and what closing it does.
 * @return {JSX.Element} The toast.
 */
export function StandingErrorToast({
  message,
  onClose,
}: StandingErrorToastProps) {
  return (
    <ErrorToast
      key={message}
      message={message}
      timeout={0}
      onClose={() => {
        onClose();
        return true;
      }}
    />
  );
}
